<template>
  <span :class="classes">{{date}}</span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    column: Object,
    row: Object
  },
  computed: {
    value() {
      return this.row[this.column.name];
    },
    isToday() {
      if (!this.value) {
        return false;
      }

      return moment(this.value).isSame(moment(), "day");
    },
    classes() {
      return {
        "text-red": this.isToday
      };
    },
    date() {
      if (moment(this.value).isBefore("2018-01-01")) {
        return this.$t("component.date.relative", {
          date: "2017-12-31"
        });
      }

      return this.value;
    }
  }
};
</script>